import React from 'react'
import Select from 'components/AddOrEditTaskPage/Select'
import FromNumberSelect from 'components/AddOrEditTaskPage/FromNumberSelect'

export default ({ automationTypeSelected }) => (
  <div>
    {automationTypeSelected === 'stage' ? <Select /> : null}
    <FromNumberSelect />
  </div>
)
